var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-panel", [
        _vm.post.image
          ? _c("div", [
              _c("img", {
                staticClass: "img-responsive post-title",
                attrs: { src: _vm.post.image, alt: _vm.post.title },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "panel-heading" }, [
          _c("div", { staticClass: "bb" }, [
            _c("h2", { staticClass: "text-lg" }, [
              _vm._v("\n          " + _vm._s(_vm.post.title) + "\n        "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "clearfix" }, [
              _c("span", { staticClass: "pull-right" }, [
                _c("small", { staticClass: "mr-sm", attrs: { dir: "ltr" } }, [
                  _c("strong", [_vm._v(_vm._s(_vm.post.author))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(":")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(this.$qt("post.authorByText")))]),
                ]),
                _vm._v("\n            -\n            "),
                _c("small", { staticClass: "mr-sm", attrs: { dir: "ltr" } }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.post.date) +
                      "\n            "
                  ),
                ]),
                _vm._v("\n            -\n            "),
                _c("small", { attrs: { dir: "ltr" } }, [
                  _c("strong", [_vm._v(_vm._s(_vm.post.commentQty))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(":")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(this.$qt("post.comment.comments"))),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _vm.post.textType === "Marked"
              ? _c("div", {
                  staticStyle: { padding: "20px" },
                  domProps: { innerHTML: _vm._s(_vm.compiledMarkdown) },
                })
              : _vm.post.textType === "Html"
              ? _c("div", { domProps: { innerHTML: _vm._s(_vm.post.text) } })
              : _vm.post.textType === "Textuality"
              ? _c("div", { staticStyle: { padding: "20px" } }, [
                  _c("p", [_vm._v(_vm._s(_vm.post.text))]),
                ])
              : _c("div", [
                  _c("span", [_vm._v(_vm._s(this.$qt("post.emptyText")))]),
                ]),
            _vm._v(" "),
            _vm._l(_vm.post.tags, function (tag) {
              return _c(
                "q-tag",
                {
                  key: tag.key,
                  staticClass: "post-tag",
                  attrs: { type: tag.key },
                },
                [_vm._v("\n        " + _vm._s(tag.value) + "\n      ")]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "dialog-footer clearfix",
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c("div", {
              staticClass: "pull-right",
              staticStyle: { "padding-left": "10px" },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pull-left",
                staticStyle: { "padding-right": "10px" },
              },
              [
                _c(
                  "q-link",
                  {
                    staticClass: "q-link",
                    attrs: {
                      underline: false,
                      target: "_blank",
                      href: "https://twitter.com/atrvasa",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fab", "twitter"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("q-divider", { attrs: { direction: "vertical" } }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.post.id !== undefined
        ? _c(
            "div",
            [
              _c(
                "q-panel",
                [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c("span", [
                      _vm._v(_vm._s(this.$qt("post.comment.comments"))),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(":")]),
                    _vm._v(" "),
                    _c("strong", [_vm._v(_vm._s(_vm.post.commentQty))]),
                  ]),
                  _vm._v(" "),
                  _c("comments", { attrs: { comments: _vm.post.comments } }),
                ],
                1
              ),
              _vm._v(" "),
              this.$store.state.session.sessionId !== "GUEST"
                ? _c(
                    "q-panel",
                    {
                      attrs: {
                        "header-text": this.$qt("post.comment.addCommentTitle"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "panel-padding" },
                        [
                          _c("add-comment", {
                            attrs: { "post-id": _vm.post.id },
                            on: { "comment-added": _vm.refreshComments },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }